import React from "react";
import { FileTextIcon, LayoutGridIcon, SearchIcon, ColumnsIcon, NotebookPenIcon, PrinterIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { tools } from "../../data/content";
const icons = [FileTextIcon, LayoutGridIcon, SearchIcon, ColumnsIcon, NotebookPenIcon];
export function Tools() {
  return <section className="w-full bg-white px-4 pb-16 sm:pb-20" aria-labelledby="tools-title" data-id="element-278" data-mp="2dhwnml1heoaa">
      <div className="mx-auto max-w-3xl rounded-3xl bg-navy-deep p-6 sm:p-10" data-id="element-279" data-mp="28k4vbpwxd05k">
        <h2 id="tools-title" className="text-center font-serif text-3xl font-bold leading-tight text-white sm:text-4xl" data-id="element-280" data-mp="23sd217mdwgbq">
          Your professional <em className="text-gold-light" data-id="element-281" data-mp="1yttfp63vp2iu">case-review tools</em>
        </h2>
        <p className="mt-3 text-center text-white/70" data-id="element-282" data-mp="1tvrx0mad757w">A complete collection of reusable tools.</p>

        <ul className="mt-8 divide-y divide-white/10" data-id="element-283" data-mp="1prk7wnzzvn95">
          {tools.map((t, i) => {
          const Icon = icons[i];
          return <li key={t.name} className="flex items-start gap-4 py-4" data-id="element-284" data-mp="159g5plsh71hn" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold/15 text-gold-light" data-id="element-285" data-mp="158533parnzs4">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-286" data-mp="w8rsuuetj76c" />
                </span>
                <div data-id="element-287" data-mp="w6yhx2x6a0sj">
                  <h3 className="font-bold text-white" data-id="element-288" data-mp="10a3i2yts5qe0">{t.name}</h3>
                  <p className="mt-0.5 text-[15px] leading-relaxed text-white/70" data-id="element-289" data-mp="108acznytfe84">{t.desc}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-6 flex items-center justify-center gap-2 text-center text-sm font-semibold text-gold-light" data-id="element-290" data-mp="1sxr3gg2vkl1p">
          <PrinterIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-291" data-mp="1eyzrp0bhjbgq" />
          Everything is designed to be downloaded, printed and reused.
        </p>
      </div>
      <div className="mx-auto max-w-3xl" data-id="element-292" data-mp="3j2n63r5yiye">
        <CtaButton label="I want the complete Decision Lab™" className="mt-10" data-id="element-293" data-mp="3m6xliv82axi" />
      </div>
    </section>;
}